import { BLOCK_CLASSES as r } from "../../constants.js";
import { defineAttrs as i } from "../../utils/typed-attrs.js";
import { stylable as c } from "../decorators/stylable.js";
import { getBackgroundColor as d } from "./spec-util.js";
const u = ["true", "false"], b = (t, e) => e ? t.concat(e, ";") : "", n = (t) => {
  var e, a, s, o, l;
  return {
    paddingTop: (e = t.style) == null ? void 0 : e.paddingTop,
    paddingBottom: (a = t.style) == null ? void 0 : a.paddingBottom,
    paddingLeft: (s = t.style) == null ? void 0 : s.paddingLeft,
    paddingRight: (o = t.style) == null ? void 0 : o.paddingRight,
    backgroundColor: d((l = t.style) == null ? void 0 : l.backgroundColor),
    colwidth: t.getAttribute("data-colwidth") ? [Number(t.getAttribute("data-colwidth"))] : null
  };
}, p = i({
  type: { default: "table" },
  responsive: { default: !1 },
  container: { default: !1 },
  stacked: { default: void 0 },
  sectionType: { default: void 0 },
  backgroundColor: { default: "" }
}), v = c({
  content: "tableRow+",
  tableRole: "table",
  isolating: !0,
  attrs: p,
  parseDOM: [
    {
      tag: "table",
      getAttrs(t) {
        var e;
        return {
          responsive: t.getAttribute("data-responsive") !== null,
          // @ts-expect-error - data-stacked is not typed
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          stacked: u.includes(t.attributes["data-stacked"]) ? (
            // @ts-expect-error - data-stacked is not typed correctly
            t.attributes["data-stacked"]
          ) : !0,
          container: t.getAttribute("data-container") !== null,
          sectionType: t.getAttribute("data-section-type") ?? void 0,
          backgroundColor: d((e = t.style) == null ? void 0 : e.backgroundColor)
        };
      }
    }
  ],
  toDOM(t) {
    if (t.attrs.container) {
      const e = t.attrs, a = e.sectionType ?? "";
      return [
        "div",
        {
          class: `${r.blockContainer} ${r.table} embercom-prosemirror-composer-section`
        },
        ["div", { class: "section-type" }, a],
        [
          "table",
          {
            class: "container intercom-template-content",
            "data-container": "true",
            "data-section-type": a,
            style: `${b("background-color: ", e.backgroundColor ?? "")}`
          },
          ["tbody", 0]
        ]
      ];
    }
    return t.attrs.responsive ? [
      "div",
      {
        class: `${r.blockContainer} ${r.table} embercom-prosemirror-composer-layout`
      },
      [
        "table",
        {
          class: "row intercom-responsive-layout-table",
          "data-responsive": "true",
          "data-stacked": typeof t.attrs.stacked == "boolean" ? t.attrs.stacked.toString() : ""
        },
        ["tbody", 0]
      ]
    ] : [
      "div",
      {
        class: `${r.blockContainer} ${r.table}`
      },
      ["table", ["tbody", 0]]
    ];
  }
}), w = {
  content: "tableCell+",
  tableRole: "row",
  parseDOM: [{ tag: "tr" }],
  toDOM() {
    return ["tr", 0];
  }
}, g = i({
  colspan: { default: 1 },
  rowspan: { default: 1 },
  colwidth: { default: null },
  responsiveClasses: { default: "" },
  container: { default: !1 }
}), A = c({
  content: "(block | list)+",
  tableRole: "cell",
  isolating: !0,
  parseDOM: [
    {
      tag: "td",
      getAttrs(t) {
        return n(t);
      }
    },
    {
      tag: "th",
      getAttrs(t) {
        return n(t);
      }
    }
  ],
  attrs: g,
  toDOM(t) {
    var s;
    const e = t.attrs;
    return t.attrs.responsiveClasses ? ["td", { "data-insertable": "true", class: e.responsiveClasses }, 0] : ["td", { "data-insertable": "true", "data-colwidth": ((s = e.colwidth) == null ? void 0 : s[0]) ?? null ?? void 0 }, 0];
  }
});
export {
  A as tableCellSpec,
  w as tableRowSpec,
  v as tableSpec
};
